'use client';

import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { useCheckEmail } from '../../hooks/use-check-email';
import { useForgotPasswordForm } from '../../hooks/use-forgot-password-form';
import ResetConfirmation from '../confirmation-info';
export default function ForgotPassword() {
  const {
    form,
    isPending,
    onSubmit,
    isSuccess
  } = useForgotPasswordForm();
  const {
    checkEmail,
    response: validEmail
  } = useCheckEmail(true);
  if (isSuccess) {
    return <ResetConfirmation>
        Password reset link has been sent to your email. Please give up to 10
        minutes for the email to send and make sure to check your spam folder.
      </ResetConfirmation>;
  }
  return <div data-sentry-component="ForgotPassword" data-sentry-source-file="index.tsx">
      <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
        Forgot your password?
      </h2>
      <p className="text-center text-gray-700 mt-2">
        Enter your email address to receive a password reset link.
      </p>
      <div className="mt-6 sm:mx-auto sm:w-full sm:max-w-md">
        <Form {...form} data-sentry-element="Form" data-sentry-source-file="index.tsx">
          <form className="space-y-6" onSubmit={form.handleSubmit(onSubmit)}>
            <FormField control={form.control} name="email" render={({
            field
          }) => <FormItem>
                  <FormLabel>Email</FormLabel>
                  <FormControl>
                    <Input placeholder="Email" type="email" autoComplete="email" {...field} onBlur={e => checkEmail(e.target.value)} />
                  </FormControl>
                  {validEmail.type && <FormMessage type={validEmail.type}>
                      {validEmail.message}
                    </FormMessage>}
                </FormItem>} data-sentry-element="FormField" data-sentry-source-file="index.tsx" />

            <Button className="w-full" loading={isPending} disabled={isPending} type="submit" data-sentry-element="Button" data-sentry-source-file="index.tsx">
              Send
            </Button>
          </form>
        </Form>

        <div className="my-4">
          <p className="block font-regular text-center">
            <Link href="/signup" className="text-blue-600 hover:text-blue-500" data-sentry-element="Link" data-sentry-source-file="index.tsx">
              Sign up instead
            </Link>
          </p>
        </div>
      </div>
    </div>;
}